import React, { useEffect, useState } from 'react';
import useActionCable from '../../hooks/useActionCable';
import Sleep from '../../utils/Sleep';

const ListItensHtml = ({etapas, status, idProcessado, processandoIds}) => (
  Object.entries(etapas).map(([key, item]) => {
    let liContent = null;
    switch (item.status) {
      case status[0]: // processando
        liContent = (
          <div>
            <strong>
              <i className='fas fa-cog fa-spin fa-lg' />
              <span className='ml-2'>{item.nome}</span>
              {
                processandoIds.length > 0 && (
                  <span className='small'>
                  : {idProcessado.length} de {processandoIds.length}
                    <span className='elli-anim' />
                  </span>
                )
              }
            </strong>
          </div>
        );
        break;
      case status[1]: // aguardando
        liContent = (
          <div className='text-muted opacity-50'>
            <i className='fas fa-stopwatch fa-lg' />
            <span className='ml-2'>{item.nome}</span>
          </div>
        );
        break;
      case status[2]: // sucesso
        liContent = (
          <div>
            <i className='fas fa-check fa-lg text-success' />
            <span className='ml-2'>{item.nome}</span>
          </div>
        );
        break;
      case status[3]: // erro
        liContent = (
          <div className='text-danger'>
            <i className='fas fa-times fa-lg' />
            <span className='ml-2'>{item.nome}</span>
          </div>
        );
        break;
    }

    return (
      <li className='list-group-item' key={key}>
        {liContent}
      </li>
    );
  })
);

const ProcessoSoLogWatch = ({track, showError, showFinish, setProcessamentoExistente, userId, processoAno}) => {
  const [baseTrack, setBaseTrack]           = useState(track);
  const {received}                          = useActionCable('LogProcessamentoSoChannel', userId, processoAno);
  const [processandoIds, setProcessandoIds] = useState([]);
  const [idProcessado, setIdProcessado]     = useState([]);

  // WATCH LOG PROCESSO SO
  useEffect(() => {
    if (received) {
      const {success, error, etapas, processando_ids, em_processamento} = received;
      if (success) {
        (async () => {
          showFinish();
          await Sleep(4000);
          Turbolinks.visit(location.toString());
        })();
      } else if (error) {
        if (error.includes("[arquivo_corrompido]")){
          showError(error.split("[arquivo_corrompido]")[1]);
        } else{
          showError('problemas ao materializar processo.');
        }
      } else if (etapas) {
        setBaseTrack(prevState => {
          const prevStateClone = prevState;
          Object.entries(etapas).forEach(([key, item]) => {
            prevStateClone.etapas[item.etapa].status = item.status;
          });

          return {...prevState, ...prevStateClone};
        });
      } else if (processando_ids) {
        if (processando_ids.itens) { setProcessandoIds(processando_ids.itens); }
        if (processando_ids.item_processado) {
          setIdProcessado(oldArray => [...oldArray, processando_ids.item_processado]);
        }
        if (processando_ids.finished) {
          setProcessandoIds([]);
          setIdProcessado([]);
        }
      } else if (em_processamento) {
        setProcessamentoExistente(true);
        setTimeout(() => Turbolinks.visit(location.toString()), 30000);
      }
    }
    return () => {};
  }, [received]);

  return (
    <>
      <ul className='list-group list-group-flush'>
        <ListItensHtml etapas={baseTrack.etapas}
                       status={baseTrack.status}
                       idProcessado={idProcessado}
                       processandoIds={processandoIds} />
      </ul>
    </>
  );
};

export default ProcessoSoLogWatch;
